module.exports = __webpack_public_path__ + "static/media/dad.cee7897c.png";